<template>
     <!-- 图片放大 -->
    <div class="imgDiv" v-if="imgShow">
        <div class="closeIcon" @click="closeImgShow()">
            <span class="el-icon-close"></span>
        </div>
        <div class="contentPart">
            <img :src="imgUrl" id="imgId" style="width:100%;" alt="荣誉资质">
        </div>
    </div>
</template>
 
<script>
export default {
   name: "imgCommon",
    props:["imgUrl"],
    components:{
    },
    data() {
        return {
            imgShow:false,
        };
    },
    methods:{
        openImgShow(){
           this.imgShow = true;
        },
        closeImgShow(){
            this.imgShow = false;
        },
    },
}
</script>

<style scoped lang="less">
     .imgDiv{
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background: rgba(0,0,0,0.8);
        border-radius: 2px;
        z-index:9999;
        .closeIcon{
            position:absolute;
            top:50px;
            right:50px;
            color: #ffffff;
            cursor: pointer;
            span{
                font-size: 22px;
            }
        }
        .contentPart{
                background: #ffffff;
                position: absolute;
                top: 15%; 
                left: calc(50% - 184px);
                // width: 30%;
                // margin-top: 60px;
                border-radius: 2px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/imgScaleBig.vue